import * as constants from '../constants';

const INITIAL_STATE = {
    items: [],
    loading: false,
    error: null,
    sending: false,
    sendResults: null,
    deleted: false,
    archiving: false,
    archiveUpdateResult: null,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;

        case constants.SURVEY_TRACKERS_REQUESTED:
            return Object.assign({}, state, {loading: true, sendResults: null, error: null, deleted: false});
        case constants.SURVEY_TRACKERS_SUCCESS:
            return Object.assign({}, state, {
                loading: false,
                items: action.payload.data.data,
                total:
                (!!action.payload.data.total && action.payload.data.total) ||
                undefined,
                error: null,
            });
        case constants.SURVEY_TRACKERS_FAILURE:
            return Object.assign({}, state, {loading: false, items: [], error: action.payload.error});

        case constants.SURVEY_TRACKERS_SEND_REQUESTED:
            return Object.assign({}, state, {sending: true, sendResults: null, error: null});
        case constants.SURVEY_TRACKERS_SEND_SUCCESS:
            return Object.assign({}, state, {sending: false, sendResults: action.payload.data, error: null});
        case constants.SURVEY_TRACKERS_SEND_FAILURE:
            return Object.assign({}, state, {loading: false, error: action.payload.error});

        case constants.SURVEY_TRACKERS_TEST_REQUESTED:
            return Object.assign({}, state, {sending: true, sendResults: null, error: null});
        case constants.SURVEY_TRACKERS_TEST_SUCCESS:
            return Object.assign({}, state, {sending: false, sendResults: action.payload.data, error: null});
        case constants.SURVEY_TRACKERS_TEST_FAILURE:
            return Object.assign({}, state, {loading: false, error: action.payload.error});

        case constants.SURVEY_TRACKERS_ARCHIVE_UPDATE_REQUESTED:
            return Object.assign({}, state, {archiving: true, archiveUpdateResult: null, error: null});
        case constants.SURVEY_TRACKERS_ARCHIVE_UPDATE_SUCCESS:
            return Object.assign({}, state, {archiving: false, archiveUpdateResult: action.payload.data, error: null});
        case constants.SURVEY_TRACKERS_ARCHIVE_UPDATE_FAILURE:
            return Object.assign({}, state, {archiving: false, error: action.payload.error});

        case constants.SURVEY_TRACKERS_DELETE_SUCCESS:
        case constants.SURVEY_WAVE_TRACKERS_DELETE_SUCCESS:
            return Object.assign({}, state, {deleted: true, error: null});
        case constants.SURVEY_TRACKERS_DELETE_FAILURE:
        case constants.SURVEY_WAVE_TRACKERS_DELETE_FAILURE:
            return Object.assign({}, state, {error: action.payload.error});
    }
    return state;
}
